var render, staticRenderFns
import script from "./SvgViewer.vue?vue&type=script&lang=js"
export * from "./SvgViewer.vue?vue&type=script&lang=js"
import style0 from "./SvgViewer.vue?vue&type=style&index=0&id=1d558bdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d558bdb",
  null
  
)

export default component.exports